module.exports = __webpack_public_path__ + "application/templates/default/inner/add-automatic-processes/add-automatic-processes.template.html";